<template>
	<div>
		<van-popup v-model="showPop" class="common-qifu-pop">
			<div class="pop-content">
				<button class="open-btn" type="button" @click="downloadLjdsApp"></button>
			</div>
		</van-popup>
		<commonLjdsDownload
			@getDownloadLink="getDownloadLink"
			ref="download"
			:tag="dlTag"
		></commonLjdsDownload>
	</div>
</template>

<script>
import {commonFn} from '../js/common.js';
import commonLjdsDownload from './commonLjdsDownload.vue';
export default {
	name: 'commonQifuPop',

	data() {
		return {
			dlTag: '',
			showPop: true,
			isShowMCGuide: false,
			isWeiXin: commonFn.parseUA().weixin
		};
	},
	components: {
		commonLjdsDownload
	},
	methods: {
		show() {
			this.showPop = true;
		},
		hide() {
			this.showPop = false;
		},
		downloadLjdsApp(nendTag = false) {
			_senseTrack('$Click', {
				$module: 'H5_window_click_PaidUser',
				$title: 'h5免费私聊弹窗点击_付费用户'
			});
			// 微信内跳转到知屿小程序承接页
			if (this.isWeiXin) {
				this.$refs.download.reLogin();
				const tokenParams = this.token ? `&token=${this.token}` : '';
				setTimeout(() => {
					location.href = `https://m.qiyuan555.cn/dist/comm/xcx?l=packageA/pages/inherit/index&channel=yqw_f9dm_00018&platform=14${tokenParams}`;
				}, 500);
				return;
			}
			this.$refs.download.downloadAPP(nendTag, '');
		},
		handleOpen() {
			this.$emit('open');
			this.hide();
		},
		getDownloadLink() {
			this.isShowMCGuide = !!commonFn.parseUA().ios;
		}
	}
};
</script>

<style lang="less" scoped>
.common-qifu-pop {
	background: transparent;
	overflow: visible;
}

.pop-content {
	width: 8.787rem;
	height: 9.773rem;
	position: relative;
	background: url('../../image/commonQifuPop/bg.png') no-repeat center / 100% 100%;
}

.open-btn {
	position: absolute;
	left: 50%;
	bottom: 0.680rem;
	width: 7.013rem;
	height: 1.707rem;
	transform: translateX(-50%);
	border: 0;
	outline: none;
	padding: 0;
	background: url('../../image/commonQifuPop/btn.png') no-repeat center / 100% 100%;
	font-family: inherit;
}
</style>



// WEBPACK FOOTER //
// commonQifuPop.vue?6dc3cd34